export default "<uoa-help\n  link-text=\"\"\n  [modalTitle]=\"title\"\n  [htmlContent]=\"content\"\n>\n</uoa-help>\n";